import { useMemo } from "react";
import InnerBannerBreadcrumb from "../../../components/shared/breadcrumb/InnerBannerBreadcrumb";
import { useGetProtectedApiDataQuery } from "../../../redux/services/apiSlice";
import { useSelector } from "react-redux";
import { getLatestDateFromData } from "../../../Utils/utils";
import PageLastUpdated from "../../../components/shared/PageLastUpdated";
import ActualGenerationChart from "./ActualGenerationChart";
import MonthlyGenerationChart from "./MonthlyGenerationChart";
import SalesVsRealization from "./SalesVsRealization";
import Loader from "../../../components/Loader";
import { useLocation } from "react-router-dom";
import useSeo from "../../../hooks/useSeo";

function Generation() {
  const { pathname } = useLocation();
  const { innerBannerImage, innerBannerTitle } = useSeo({ pathname });
  const { languageType } = useSelector((state) => state.homeSlice);

  const { data: monthlyGenerationData = {} } = useGetProtectedApiDataQuery({
    url: "react-api-generation",
    lang: languageType,
  });

  const monthWiseData = monthlyGenerationData?.monthwise_sums ?? {};

  const { data: generationLastUpdate = [], isLoading } =
    useGetProtectedApiDataQuery({
      url: "generation_update",
      lang: languageType,
    });

  const lastUpdatedOn = useMemo(() => {
    return getLatestDateFromData(generationLastUpdate);
  }, [generationLastUpdate]);

  if (isLoading) {
    return <Loader />;
  }

  return (
    <>
      <InnerBannerBreadcrumb
        bannerImage={innerBannerImage}
        title={innerBannerTitle}
        isActive={innerBannerTitle}
        titleLink="/generation"
        levelTwo={false}
        levelThree={false}
      />

      <div className="inner-container">
        <div className="container">
          <div className="container">
            <PageLastUpdated lastUpdatedOn={lastUpdatedOn} />
            <div className="row">
              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                <MonthlyGenerationChart monthWiseData={monthWiseData} />
              </div>
              <div className="col-12 col-sm-12 col-md-12 col-lg-6 print-contact1">
                <SalesVsRealization />
              </div>
              <div className="col-12 col-sm-12 col-md-12 col-lg-6 print-contact1">
                <ActualGenerationChart />
              </div>
            </div>
            {/* <div className="row">
              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                <CapacityVsGeneration />
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
}

export default Generation;
